import {
  SET_DATA_TAG_ALL_REPORTS,
  SET_DATA_TAG_REPORTS_LOADER,
  SET_DATA_TAG_SNACKBAR,
  CLEAR_DATA_TAG_SNACKBAR,
  SET_DATA_TAG_CONTENT_ACTION,
  SET_DATA_TAG_UPLOAD_LOADER,
  UPLOAD_DATA_TAG_REPORT_SUCCESS,
  UPLOAD_DATA_TAG_REPORT_FAILURE,
  SET_UPLOAD_PROGRESS,
  CLEAR_UPLOAD_STATE,
} from "../../features/Data Tag/DataTagConstants";

const initialState = {
  allReports: { reports: [], totalElements: 0, tenantId: null },
  loader: false,
  snackBarMessage: {},
  contentAction: { reportId: null, mode: null },
  uploadLoader: false,
  uploadProgress: 0,
  uploadSnackBarMessage: {},
};

export const DataTagReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA_TAG_ALL_REPORTS:
      return {
        ...state,
        allReports: action.payload,
      };

    case SET_DATA_TAG_REPORTS_LOADER:
      return {
        ...state,
        loader: action.payload,
      };

    case SET_DATA_TAG_SNACKBAR:
      return {
        ...state,
        snackBarMessage: action.payload,
      };

    case CLEAR_DATA_TAG_SNACKBAR:
      return {
        ...state,
        snackBarMessage: {},
      };

    case SET_DATA_TAG_CONTENT_ACTION:
      return {
        ...state,
        contentAction: action.payload,
      };

    case SET_DATA_TAG_UPLOAD_LOADER:
      return {
        ...state,
        uploadLoader: action.payload,
      };

    case SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgress: action.payload,
      };

    case UPLOAD_DATA_TAG_REPORT_SUCCESS:
      return {
        ...state,
        uploadLoader: false,
        uploadProgress: 100,
        uploadSnackBarMessage: {
          status: "success",
          message: action.payload || "Report uploaded successfully!",
        },
      };

    case UPLOAD_DATA_TAG_REPORT_FAILURE:
      return {
        ...state,
        uploadLoader: false,
        uploadSnackBarMessage: {
          status: "error",
          message: action.payload || "Failed to upload report",
        },
      };

    case CLEAR_UPLOAD_STATE:
      return {
        ...state,
        uploadLoader: false,
        uploadProgress: 0,
        uploadSnackBarMessage: {},
      };

    default:
      return state;
  }
};